import Component from '@glimmer/component';
import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import {
  HdsCardContainer,
  HdsIconTile,
  HdsTextDisplay,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { classNames } from 'core/helpers';
import { boxMargin, boxPadding } from 'core/modifiers';

/**
 * The organization in context.
 * @argument organization
 * @type {Object}
 */
/**
 *
 * `PageOrganizationsDetailUserPrincipalsCard` is a card for the organization
 * dashboard that renders service principal data and a link to the service
 * principal list page.
 *
 *
 * ```
 * <Page::Organizations::Detail::UserPrincipalsCard
 *   @organization={{this.organization}}
 * />
 * ```
 *
 * @class PageOrganizationsDetailUserPrincipalsCard
 *
 */
export default class PageOrganizationsDetailUserPrincipalsCard extends Component {
  <template>
    <HdsCardContainer
      @level="mid"
      @hasBorder="true"
      class="hcp-flex"
      {{boxPadding "lg"}}
      ...attributes
    >
      <Flex @direction="column" @justifyContent="space-between" @grow={{1}}>
        <div {{boxMargin "0 0 md 0"}}>
          <Flex
            @alignItems="center"
            @direction="row"
            @gap="md"
            {{boxMargin "0 0 lg 0"}}
          >
            <HdsIconTile @icon="user" />
            <HdsTextDisplay
              @size="400"
              @weight="bold"
              @tag="h2"
              data-test-organization-dashboard-user-principals-header
            >
              {{t
                "components.page.organizations.detail.user-principals-card.title"
              }}
            </HdsTextDisplay>
          </Flex>
          <p
            class={{classNames
              "hds-typography-body-200"
              "hds-font-weight-regular"
              "hds-foreground-faint"
            }}
            data-test-organization-dashboard-user-principals-message
          >
            {{t
              "components.page.organizations.detail.user-principals-card.there-are-active-principals"
              userPrincipalCount=this.userPrincipalCount
            }}
          </p>
        </div>
        <div>
          <HdsLinkStandalone
            @icon="arrow-right"
            @iconPosition="trailing"
            @query={{hash org_id=@organization.id project_id=null}}
            @route="cloud.access-control"
            @text={{t
              "components.page.organizations.detail.user-principals-card.view-access-control"
            }}
            data-test-organization-dashboard-user-principals-access-control-link
          />
        </div>
      </Flex>
    </HdsCardContainer>
  </template>
}
